import { render, staticRenderFns } from "./addPersonalAccountData.vue?vue&type=template&id=29008edd&scoped=true&"
import script from "./addPersonalAccountData.vue?vue&type=script&lang=js&"
export * from "./addPersonalAccountData.vue?vue&type=script&lang=js&"
import style0 from "./addPersonalAccountData.vue?vue&type=style&index=0&id=29008edd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29008edd",
  null
  
)

export default component.exports